import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { Transaction } from './types';
import { DateTime } from 'luxon';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export async function copyToClipboard(text: string) {
  try {
    await navigator.clipboard.writeText(text);
    console.log('Content copied to clipboard!');
  } catch (err) {
    console.error('Failed to copy: ', err);
  }
}

type GroupedTransactions = { [key: string]: Transaction[] };

export function groupTransactionsByDate(
  transactions: Transaction[],
): GroupedTransactions {
  return transactions.reduce((groups, tx) => {
    // Extract only the date part (e.g., '2025-10-27')
    const date = tx.created_at.split('T')[0];

    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(tx);

    return groups;
  }, {});
}

export function convertDate(isoString: string) {
  const date = DateTime.fromISO(isoString, { zone: 'utc' }).toLocal();

  const formattedDate = date.toLocaleString(DateTime.DATE_SHORT);
  const formattedTime = date.toLocaleString(DateTime.TIME_WITH_SECONDS);

  return { formattedDate, formattedTime };
}

export function checkToday(isoString: string) {
  const inputDate = DateTime.fromISO(isoString, { zone: 'utc' })
    .toLocal()
    .startOf('day');
  const today = DateTime.local().startOf('day');

  return inputDate.hasSame(today, 'day');
}
